var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',{style:({width: _vm.width, height: _vm.height}),attrs:{"src":_vm.value,"fit":_vm.fit}})
}
var staticRenderFns = []

export { render, staticRenderFns }